<p>check-in-out-report works!</p>
